import { type ElementType } from 'react';
import { Crown, Shield, Eye } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { OrgRole } from '@/features/organizations/services/schemas';

const roleMap: Record<OrgRole, { icon: ElementType; cls: string; label: string }> = {
  full: { icon: Crown, cls: 'bg-amber-50 text-amber-700 border-amber-200', label: 'Admin' },
  write: { icon: Shield, cls: 'bg-blue-50 text-blue-700 border-blue-200', label: 'Editor' },
  read: { icon: Eye, cls: 'bg-gray-50 text-gray-600 border-gray-200', label: 'Reader' },
};

export function RoleBadge({ role }: { role: OrgRole }) {
  const { icon: Icon, cls, label } = roleMap[role];
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[11px] font-semibold border',
        cls
      )}
    >
      <Icon size={10} />
      {label}
    </span>
  );
}
